import { ICreateBancoPagamentoUseCase } from "../../../presentation/useCases/create/create_banco_pagamento_use_case";
import { BancoPagamento } from "../../models/banco_pagamento";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateBancoPagamentoUseCase
 */

export class CreateBancoPagamentoUseCase implements ICreateBancoPagamentoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createBancoPagamento(form: BancoPagamento): Promise<number> {
    return await this.repository.createBancoPagamento(form)

  }

}
